import { render } from "./SponsorshipView.vue?vue&type=template&id=90845eb8"
import script from "./SponsorshipView.vue?vue&type=script&lang=js"
export * from "./SponsorshipView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__